import React from 'react';

import { H5, P1 } from '../Title';
import { openDataUri } from '~/helpers/openDataUri';

// Deixa o texto quebrar normalmente sem quebrar palavras, jogando palavras para a próxima linha.
const wordWrapBase = {
  wordBreak: 'normal',
  overflowWrap: 'normal',
  hyphens: 'none',
};

const mappedTypesComponents = {
  'header': {
    component: H5,
    styles: { lineHeight: '3.2rem', padding: '1.6rem 1rem', fontWeight: 'bold', ...wordWrapBase }
  },
  'text': {
    component: P1,
    styles: { lineHeight: '1.6rem', padding: '1.6rem 1rem', ...wordWrapBase }
  },
  'warn': {
    component: P1,
    styles: { lineHeight: '1.6rem', padding: '1.6rem 1rem', color: 'rgb(66, 0, 128)', fontWeight: 'bold', ...wordWrapBase }
  },
  'link': {
    component: P1,
    styles: { lineHeight: '1.6rem', padding: '1.6rem 1rem', ...wordWrapBase }
  }
}

const renderContent = (type, content) => {
  if (type === 'link') {
    if (typeof content === 'string' && content.startsWith('data:')) {
      return (
        <a href="#" onClick={(e) => { e.preventDefault(); openDataUri(content); }}>
          Abrir comprovante
        </a>
      );
    }

    return (
      <a href={content} target="_blank" rel="noopener noreferrer">
        {content}
      </a>
    );
  }

  return content;
}

const getComponentFromKey = (subq, idnx) => {
  const typeComponent = mappedTypesComponents[subq[1]['type']];

  return (
    <typeComponent.component key={idnx} style={typeComponent.styles}>
      <strong>{subq[0]}</strong>
      :
      {' '}
      {renderContent(subq[1]['type'], subq[1]['content'])}
    </typeComponent.component>
  )
}

const ChaveValorTyped = ({ data }) => {
  return (
  <>
    {data?.map((values, count) => (
      <>
      {Object.entries(values).map((subq, idnx) => getComponentFromKey(subq, idnx))}
      </>
    ))}
  </>)
}
;


export default ChaveValorTyped;
